import Text from './Text/Text';
import ButtonScope from './ButtonScope/ButtonScope';
import ButtonItem from './ButtonItem/ButtonItem';
import ListScope from './ListScope/ListScope';
import ListItem from './ListItem/ListItem';
import SendMedia from './SendMedia/SendMedia';
import DynamicList from "./DynamicList/DynamicList";
import { types } from './types';


function Actions(action, showAlert, variables, setOpenVariable, automId, automVersionId, variableRender, automaticallyWhatsappVariableCreation, getVariables, actions) {
    switch (action.actionName) {
        case types.TEXT:
            return <Text action={action} variables={variables} setOpenVariable={setOpenVariable} automId={automId}
                showAlert={showAlert} automVersionId={automVersionId}
                automaticallyWhatsappVariableCreation={automaticallyWhatsappVariableCreation} actions={actions} />;
        case types.BUTTONSCOPE:
            return <ButtonScope action={action} variables={variables} setOpenVariable={setOpenVariable}
                automId={automId}
                showAlert={showAlert} automVersionId={automVersionId} />;
        case types.LISTSCOPE:
            return <ListScope action={action} variables={variables} setOpenVariable={setOpenVariable}
                automId={automId}
                showAlert={showAlert} automVersionId={automVersionId} />;
        case types.LISTITEM:
            return <ListItem action={action} variables={variables} setOpenVariable={setOpenVariable}
                automId={automId}
                showAlert={showAlert} automVersionId={automVersionId} />;
        case types.BUTTONITEM:
            return <ButtonItem action={action} variables={variables} setOpenVariable={setOpenVariable}
                automId={automId}
                showAlert={showAlert} automVersionId={automVersionId} />;
        case types.SENDMEDIA:
            return <SendMedia action={action} variables={variables} setOpenVariable={setOpenVariable} />;
        case types.DYNAMICLIST:
            return <DynamicList action={action} variables={variables} setOpenVariable={setOpenVariable}
                automId={automId}
                showAlert={showAlert} automVersionId={automVersionId} getVariables={getVariables} />;
        default:
            break;
    }
}

export default Actions;

